import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-8" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "card-toolbar" }
const _hoisted_5 = {
  class: "card-body overflow-auto",
  style: {"white-space":"nowrap"}
}
const _hoisted_6 = {
  class: "table align-middle fs-6 gy-5",
  id: "kt_ecommerce_add_product_reviews"
}
const _hoisted_7 = { class: "text-start text-muted fw-bold fs-7 text-uppercase gs-0" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("th", null, "id", -1)
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = {
  key: 2,
  class: "fw-semibold text-gray-900"
}
const _hoisted_12 = { class: "d-flex gap-4 align-items-center" }
const _hoisted_13 = { class: "spinner-border text-primary" }
const _hoisted_14 = { class: "" }
const _hoisted_15 = ["onClick"]

import { onMounted, ref } from "vue";
import DateUtils from "@/core/utils/DateUtils";
import GlobalService from "../../../services/TenantGlobalService";
import { TopicTypes } from "@/core/types/TopicTypes";
import LoadingRing from "@/components/LoadingRing.vue";
import NoDataBox from "@/components/NoDataBox.vue";
import CreateNotice from "../components/CreateNotice.vue";
import NoticeDetail from "../components/NoticeDetail.vue";
import TopicService from "../services/TopicService";
import TableFooter from "@/components/TableFooter.vue";
import { ElNotification } from "element-plus";


export default /*#__PURE__*/_defineComponent({
  __name: 'NoticeTopic',
  setup(__props) {

const noticeList = ref(Array<any>());
const isLoading = ref(true);
const createNoticeRef = ref<InstanceType<typeof CreateNotice>>();
const noticeDetailRef = ref<any>(null);

const criteria = ref({
  type: TopicTypes.Notice,
  page: 1,
  size: 20,
  sortField: "createdOn",
} as any);

onMounted(async () => {
  fetchData(1);
});

const fetchData = async (_page: number) => {
  isLoading.value = true;
  criteria.value.page = _page;
  try {
    const res = await GlobalService.queryEventTopics(criteria.value);

    if (res && res.data) {
      noticeList.value = res.data.map((item) => ({
        ...item,
        publishStatus: switchOn(item.effectiveTo),
        publishLoading: false,
      }));
      criteria.value = res.criteria;
    }
  } catch (e) {
    console.log(e);
  }

  isLoading.value = false;
};
const pageChange = (page: number) => {
  fetchData(page);
};

const publishToggle = (item: any) => {
  isLoading.value = true;
  item.publishLoading = true;

  try {
    const newDate = new Date();
    if (item.publishStatus == true) {
      newDate.setFullYear(newDate.getFullYear() + 50);
    } else {
      newDate.setFullYear(newDate.getFullYear() - 50);
    }

    const data = {
      type: TopicTypes.Notice,
      title: item.title,
      effectiveFrom: item.effectiveFrom,
      effectiveTo: newDate,
    };
    TopicService.updateNoticeTime(item.id, data);
    notification(1);
  } catch (e) {
    notification(0);
  }
  isLoading.value = false;
  item.publishLoading = false;
};

const switchOn = (endDate) => {
  const today = new Date();
  const eventEndDate = new Date(endDate);
  today.setHours(0, 0, 0, 0);
  return eventEndDate > today;
};

const showNoticeDetail = (detail: any) => {
  noticeDetailRef.value?.show(detail);
};

const onEventSubmitted = () => {
  fetchData(1);
};

const deleteItem = async (itemId: number) => {
  isLoading.value = true;
  try {
    await TopicService.deleteNotice(itemId);
    notification(1);
    fetchData(1);
  } catch (e) {
    notification(0);
  }
  isLoading.value = false;
};

const notification = (type: number) => {
  if (type == 1) {
    ElNotification({
      title: "Success",
      message: "Update success!",
      type: "success",
      offset: 150,
    });
  } else {
    ElNotification({
      title: "Error",
      message: "Update failed!",
      type: "error",
      offset: 150,
    });
  }
};

return (_ctx: any,_cache: any) => {
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_TimeShow = _resolveComponent("TimeShow")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("title.notice")), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          class: "btn btn-success",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (createNoticeRef.value?.show()))
        }, _toDisplayString(_ctx.$t("action.new")), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("table", _hoisted_6, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", _hoisted_7, [
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("tip.published")), 1),
            _hoisted_8,
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.title")), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.language")), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("tip.publishedDate")), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("action.detail")), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("action.delete")), 1)
          ])
        ]),
        (isLoading.value)
          ? (_openBlock(), _createElementBlock("tbody", _hoisted_9, [
              _createVNode(LoadingRing)
            ]))
          : (!isLoading.value && noticeList.value.length === 0)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_10, [
                _createVNode(NoDataBox)
              ]))
            : (_openBlock(), _createElementBlock("tbody", _hoisted_11, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(noticeList.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    _createElementVNode("td", _hoisted_12, [
                      _createVNode(_component_el_switch, {
                        modelValue: item.publishStatus,
                        "onUpdate:modelValue": ($event: any) => ((item.publishStatus) = $event),
                        onChange: () => publishToggle(item),
                        width: "50"
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"]),
                      _withDirectives(_createElementVNode("div", _hoisted_13, null, 512), [
                        [_vShow, item.publishLoading]
                      ])
                    ]),
                    _createElementVNode("td", null, _toDisplayString(item.id), 1),
                    _createElementVNode("td", _hoisted_14, _toDisplayString(item["contents"]["en-us"].title), 1),
                    _createElementVNode("td", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.contents, (_, key, index) => {
                        return (_openBlock(), _createElementBlock("span", {
                          class: "badge text-bg-warning me-1",
                          key: index
                        }, _toDisplayString(key), 1))
                      }), 128))
                    ]),
                    _createElementVNode("td", null, [
                      _createVNode(_component_TimeShow, {
                        type: "inFields",
                        "date-iso-string": item.createdOn
                      }, null, 8, ["date-iso-string"])
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", {
                        class: "btn btn-light btn-success btn-sm",
                        onClick: ($event: any) => (showNoticeDetail(item))
                      }, _toDisplayString(_ctx.$t("title.details")), 9, _hoisted_15)
                    ]),
                    _createElementVNode("td", null, [
                      _createVNode(_component_el_popconfirm, {
                        width: "160",
                        title: "Confirm to delete",
                        "confirm-button-text": "Confirm",
                        onConfirm: ($event: any) => (deleteItem(item.id))
                      }, {
                        reference: _withCtx(() => [
                          _createVNode(_component_el_button, { class: "btn btn-light btn-danger btn-sm" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("action.delete")), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 2
                      }, 1032, ["onConfirm"])
                    ])
                  ]))
                }), 128))
              ]))
      ]),
      _createVNode(TableFooter, {
        onPageChange: pageChange,
        criteria: criteria.value
      }, null, 8, ["criteria"])
    ]),
    _createVNode(NoticeDetail, {
      ref_key: "noticeDetailRef",
      ref: noticeDetailRef,
      onEventSubmit: onEventSubmitted
    }, null, 512),
    _createVNode(CreateNotice, {
      ref_key: "createNoticeRef",
      ref: createNoticeRef,
      onEventSubmit: onEventSubmitted
    }, null, 512)
  ]))
}
}

})